import axios from 'axios'
import { Auth } from 'aws-amplify'
import { simulateValidationError } from '~/helpers'
import I18n from '~/i18n'

export default {
    logOut() {
        return Auth.signOut()
    },

    forgotPassword(email) {
        return Auth.forgotPassword(email)
    },

    logIn(email, password) {
        return Auth.signIn(email, password)
    },

    resendVerification(email) {
        return Auth.resendSignUp(email)
    },

    sendVerificationEmail(userId) {
        return axios.post(`/users/${userId}/verification-email`)
    },

    resendVerificationEmail(email, id) {
        return axios.post(`/unauthenticated/users/resend-verification-email`, { email, userId: Number(id) })
    },

    verifyEmail(data) {
        return axios.post('/unauthenticated/auth/verify-email', data)
    },

    changePassword(oldPassword, newPassword) {
        return Auth.currentAuthenticatedUser().then((user) => {
            return Auth.changePassword(user, oldPassword, newPassword).catch((err) => {
                if (err.code === 'NotAuthorizedException') {
                    return simulateValidationError({
                        currentPassword: I18n.t('forms.auth.reset_password.errors.password.wrong'),
                    })
                } else if (err.code === 'InvalidPasswordException') {
                    return simulateValidationError({
                        newPassword: I18n.t('forms.auth.reset_password.errors.password.length'),
                    })
                }
                return simulateValidationError({
                    newPassword: I18n.t('forms.auth.reset_password.errors.password.something_wrong'),
                })
            })
        })
    },

    setPassword(email, password, code) {
        return axios.post('/unauthenticated/users/set-password', { email, password, code })
    },

    ehrLogin(email, accessToken) {
        return axios.post('/unauthenticated/auth/ehr-login', { email, accessToken })
    },
}
